export const extractObjectName = (
  street?: string,
  name1?: string
): string | null => {
  if (!street) return null;
  const parts = street.split("#");
  return parts[1]?.trim() || name1 || null;
};

export const sortProperties = <T extends { street?: string; name1?: string }>(
  properties: T[]
): T[] => {
  const getObjectName = (p: T): string =>
    (extractObjectName(p.street, p.name1) || "").trim();

  const getFirstNumber = (str: string): number | null => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  };

  const getPrefix = (str: string): string =>
    str.replace(/\d+.*/, "").trim().toLowerCase(); // get part before number

  return [...properties].sort((a, b) => {
    const nameA = getObjectName(a);
    const nameB = getObjectName(b);

    const hasObjectNameA = !!nameA;
    const hasObjectNameB = !!nameB;

    // Properties with objectName first
    if (hasObjectNameA && !hasObjectNameB) return -1;
    if (!hasObjectNameA && hasObjectNameB) return 1;

    // Extract prefixes and numbers
    const prefixA = getPrefix(nameA);
    const prefixB = getPrefix(nameB);
    const numA = getFirstNumber(nameA);
    const numB = getFirstNumber(nameB);

    // Step 1: Compare prefixes alphabetically
    const prefixCompare = prefixA.localeCompare(prefixB);
    if (prefixCompare !== 0) return prefixCompare;

    // Step 2: If same prefix, compare numbers numerically (if both exist)
    if (numA !== null && numB !== null) return numA - numB;
    if (numA !== null) return -1;
    if (numB !== null) return 1;

    // Step 3: Fallback to full alphabetical comparison
    return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
  });
};
